<p-form-wrapper id="add-collab" titleWrapper="Créer un accès hors ID.NOT">
  <div body class="px-4">
    <div *ngIf="showSuccessMsg" class="alert alert-success" role="alert">
      <strong>Succès ! </strong>
      <span>Un email a été bien envoyé à ce collaborateur.</span>
    </div>
    <div *ngIf="showErrorMsg" class="alert alert-danger" role="alert">
      <strong>Erreur ! </strong>
      <span>{{ errorMessage }}</span>
    </div>

    <form
      id="add-collab-form"
      accept-charset="UTF-8"
      [formGroup]="addCollabForm"
    >
      <p-input
        [formControl]="this.addCollabForm.controls.prenom"
        id="firstname"
        name="firstname"
        label="Prénom"
        description="Entrer le prénom du collaborateur"
        errorMessage="Prénom obligatoire"
      ></p-input>
      <p-input
        [formControl]="this.addCollabForm.controls.nom"
        id="lastname"
        name="lastname"
        label="Nom"
        description="Entrer le nom du collaborateur"
        errorMessage="Nom obligatoire"
      ></p-input>
      <p-input
        [formControl]="this.addCollabForm.controls.email"
        id="email"
        type="email"
        name="email"
        label="Email"
        description="Entrer l'adresse email du collaborateur"
        errorMessage="Adresse éléctronique invalide"
      ></p-input>
      <div class="mt-4">
        <p-button
          id="btn-confirmer"
          label="Confirmer"
          [width]="25"
          [disabled]="!addCollabForm.valid || loading"
          [loading]="loading"
          (click)="createCollab()"
        ></p-button>
      </div>
    </form>
  </div>
</p-form-wrapper>
